import { default as _  } from 'lodash';
import { default as $ } from 'jquery';
import { format } from 'date-fns';
import { Injectable } from '@angular/core';
import { UserService } from 'app/Shared/Services/user.service';
import { UrlsService } from 'app/Shared/Services/urls.service';
import { default as GridColumnsJSON } from './cais-fdid/CAIS-FDID-Grid-Columns.json';
import { GridService } from 'app/Shared/Services/grid.service';
import { DataService } from 'app/Shared/Services/data.service';
import { SharedHttpClientService } from 'app/Shared/Services/shared-http-client.service';
import { APIURL } from 'app/Shared/Constant/API_Urls';
import { BehaviorSubject, map } from 'rxjs';

@Injectable(
  {providedIn: 'root'}
)
export class CaisServiceService {

  isDisplayTIDGenerator: boolean = false;
  isLegalEntityForeignTIDGenerator: boolean = false;
  isNaturalPersonForeignTIDGenerator: boolean = false;
  isDisplayCustomerSearchList: boolean = false;
  GridColumns : any  = GridColumnsJSON["CAISFDIDCols"];
  AddressGridColumns: any = GridColumnsJSON["AddressesDataCols"];
  NaturalPersonGridColumns : any= GridColumnsJSON["CAISNaturalPersonCols"];
  LegalEntityGridColumns: any = GridColumnsJSON["CAISLegalEntityCols"];
  LTIDGridColumns: any = GridColumnsJSON["CAISLTIDCols"];
  TIDGridColumns: any = GridColumnsJSON["CAISTIDCols"];

  LTIDDataSet: any[] = [{ largeTraderID: '', ltidEffectiveDate: '', ltidEndDate: '', ltidEndReason: '' }];
  addScreenNegotiatedFields: Array<string> = ['Fdid Record ID', 'Id', 'Action', 'Firm', 'FDID Action', 'Active', 'Report Date', 'Report Reason', 'Is Natural Person', 'File ID', 'Init Finra Status', 'Init Finra Submission File Name', 'Initial Finra Submission Date', 'Initial Finra Feedback Date', 'Last Finra Status', 'Last Finra Submission File Name', 'Last Finra Submission Date', 'Last Finra Feedback DateTime', 'Updated Date', 'Updated User', 'Created Date', 'Created User'];
  editScreenNegotiatedFields: Array<string> = ['Fdid Record ID', 'Id', 'Action', 'Firm', 'FDID Action', 'Active', 'Report Date', 'Report Reason', 'Is Natural Person', 'File ID', 'Init Finra Status', 'Init Finra Submission File Name', 'Initial Finra Submission Date', 'Initial Finra Feedback Date', 'Last Finra Status', 'Last Finra Submission File Name', 'Last Finra Submission Date', 'Last Finra Feedback DateTime', 'Updated Date', 'Updated User', 'Created Date', 'Created User'];
  viewScreenNegotiatedFields: Array<string> = ['Fdid Record ID', 'Id', 'Action', 'Firm', 'FDID Action', 'Active', 'Is Natural Person', 'File ID', 'Init Finra Status', 'Init Finra Submission File Name', 'Initial Finra Submission Date', 'Initial Finra Feedback Date', 'Last Finra Status', 'Last Finra Submission File Name', 'Last Finra Submission Date', 'Last Finra Feedback DateTime', 'Updated Date', 'Updated User', 'Created Date', 'Created User'];
  CommonNegotiatedFields: Array<string> = ['File ID'];
  DisabledFields: Array<string> = ['FDID End Date', 'FDID End Reason', 'Role End Date', 'Role End Reason', 'Rep By TID Value'];
  editDisabledFields: Array<string> = ['Received FDID', 'TID Value'];
  ExceptionalFDIDScreenFields: Array<string> = ['Customer Type', 'Role', 'Has Discretion', 'Role Start Date', 'TID Type', 'Foreign TID Type', 'Role End Date', 'Role End Reason', 'Customer Record ID', 'In Customer Record ID', 'Foreign TID Country', 'TID Value', 'Rep By TID Type', 'Rep by Foreign TID Type', 'Replacing Foreign TID Country', 'Rep By TID Value'];
  CountryFields: Array<string> = ['Foreign TID Country', 'Replacing Foreign TID Country'];
  TIDTypes: Array<string> = ['FOREIGN'];
  foreignTIDTypes: Array<string> = ['DRIVERLICENSE','NATIONALID','PASSPORT','PERMANENT','OTHGOVT'];
  customerRoleTypes: Array<string> = ['NTHOLDER', 'TRDHOLDER'];
  customerDiscretionRoleTypes: Array<string> = ['AUTH3RD', 'AUTHREP'];
  TIDUpdateStatuses: Array<string> = ['Actual', 'Cloned'];
  editabledCaisCorrectionFields: Array<string> = ['EIN', 'LEI','TID Type', 'Foreign TID Type','Foreign TID Country','TID Value'];


  addressColumns: any = [];
  addressColumnJson: any = [];
  NaturalPersoncols: any = [];
  LegalEntitycols: any = [];
  TIDcols: any = [];
  LTIDcols: any = [];


  FDIDScreenDataDetails: any = [];
  FDIDAddressDetails: any = [];
  NaturalPersonDataDetails: any = [];
  LegalEntityDataDetails: any = [];
  AddressDetails: any = [];
  NaturalPersonAddressDetails: any = [];
  LegalEntityAddressDetails: any = [];
  fdidScreenDataDetails: any = [];
  NaturalPersonScreenDataDetails: any = [];
  LegalEntityScreenDataDetails: any = [];
  removedCustomers: any[] = [];
  LTIDScreenDataDetails: any = [];
  TIDScreenDataDetails: any = [];

  yearField: any = ['Year Of Birth'];

  tbldatamsg = 'L o a d i n g . . . . .';
  cols: any = [];
  filterCols: any = [];
  actionType!: string;
  storeBirthYear: any=[];
  private LegalEntityForeignTIDValue = new BehaviorSubject<any>('');
  currentLegalEntityTIDValue = this.LegalEntityForeignTIDValue.asObservable();
  private NaturalPersonForeignTIDValue = new BehaviorSubject<any>('');
  currentNaturalPersonTIDValue = this.NaturalPersonForeignTIDValue.asObservable();
  activeIndex: any ;
  searchCustomerIndex:any;
  FDIDIndex:any

  constructor(private userService: UserService,
    private urlService: UrlsService,
    private gridService: GridService,
    public dataService: DataService,
    private sharedHttpClientService: SharedHttpClientService) { }

  loadFDIDDetails(fdidDetails: any, selectedRow: any) {
    /* FDID Details */
    let FDIDScreenDataDetails: any;
    FDIDScreenDataDetails = fdidDetails;
    if(selectedRow["fdidRecordID"]){
    FDIDScreenDataDetails["fdidRecordID"] = selectedRow["fdidRecordID"];
    }
    if (FDIDScreenDataDetails != null) {
      Object.keys(FDIDScreenDataDetails).forEach((key) => {
          if(_.includes(['fdidDate', 'fdidEndDate'], key)) {
            FDIDScreenDataDetails[key] = (FDIDScreenDataDetails[key] ? this.userService.getUTCDate_yyyyMMdd(FDIDScreenDataDetails[key]) : FDIDScreenDataDetails[key]);
          }
          if(_.includes(['accountType'], key)) {
            FDIDScreenDataDetails[key] = _.split(FDIDScreenDataDetails[key], '@');
          }
      });
    }
    this.FDIDScreenDataDetails=FDIDScreenDataDetails;
    return this.FDIDScreenDataDetails;
  }

  loadFDIDAddress(addrDetails: any,) {
    /* FDID Address Details */
    let addressDetailsArray = [];

    if (addrDetails && Object.keys(addrDetails).length > 0) {
      for (let j = 0; j < 4; j++) {
        /* Retrieve Country & Region Code */
        let addressData={
         'addr_addrLine1': (addrDetails[j] && addrDetails[j]['addrLine1'] != null  ? addrDetails[j]['addrLine1'] : ''),
          'addr_addrLine2': (addrDetails[j] && addrDetails[j]['addrLine2'] != null ? addrDetails[j]['addrLine2'] : ''),
          'addr_addrLine3': (addrDetails[j] && addrDetails[j]['addrLine3'] != null ? addrDetails[j]['addrLine3'] : ''),
          'addr_addrLine4': (addrDetails[j] && addrDetails[j]['addrLine4'] != null ? addrDetails[j]['addrLine4'] : ''),
          'addr_city': (addrDetails[j] && addrDetails[j]['city'] != null ? addrDetails[j]['city'] : ''),
          'addr_regionCode': (addrDetails[j] && addrDetails[j]['regionCode'] != null ? addrDetails[j]['regionCode'] : ''),
          'addr_countryCode':(addrDetails[j] && addrDetails[j]['countryCode'] != null ? addrDetails[j]['countryCode'] : ''),
          'addr_postalCode': (addrDetails[j] && addrDetails[j]['postalCode'] != null ? addrDetails[j]['postalCode'] : '')
        }
        if(Object.values(addressData).some(value=>value && value.trim() !=='')){
          addressDetailsArray.push(addressData);
        }
      }
      /* Add a Blank Address Row if don't have any Addresses */
        if(addressDetailsArray.length === 0) {
          addressDetailsArray.push({
              'addr_addrLine1': '', 'addr_addrLine2': '', 'addr_addrLine3': '', 'addr_addrLine4': '', 'addr_city': '', 'addr_regionCode': '', 'addr_countryCode': '', 'addr_postalCode': ''
          });
        }
      /* End of Adding a Blank Address Row if don't have any Addresses */
    } else {
      addressDetailsArray.push({
        'addr_addrLine1': '', 'addr_addrLine2': '', 'addr_addrLine3': '', 'addr_addrLine4': '', 'addr_city': '', 'addr_regionCode': '', 'addr_countryCode': '', 'addr_postalCode': ''
      });

    }
    this.FDIDAddressDetails=addressDetailsArray;
    return this.FDIDAddressDetails;
  }

  loadLTIDDetails(ltidDetails: any) {
    /* LTID Details */
    let ltidDataDetails=ltidDetails.length > 0 ? ltidDetails : [{ largeTraderID: '', ltidEffectiveDate: '', ltidEndDate: '', ltidEndReason: '' }];
    this.LTIDDataSet=ltidDataDetails;
    return this.LTIDDataSet;
  }

  loadLegalEntityDetails(legalEntityDetails: any) {
    /* Legal Entity Details */
    let LegalEntityDataDetails:any = [];
    LegalEntityDataDetails = legalEntityDetails.length > 0 ? legalEntityDetails : LegalEntityDataDetails;

    /* Retrieve Foreign TID Country & Replacing Foreign TID Country */
    if (LegalEntityDataDetails.length > 0) {
      for (let i = 0; i < LegalEntityDataDetails.length; i++) {
        /* Set TID Update Flags */
          this.setClonedCustomerTIDFlag(LegalEntityDataDetails[i], legalEntityDetails); // Search & Set Cloned Customer Flag
        /* End of setting TID Update Flags */
        let LEColumns = Object.keys(LegalEntityDataDetails[i]);
        for (let j = 0; j < LEColumns.length; j++) {
          if(_.includes(['roleStartDate', 'roleEndDate'], LEColumns[j])) {
            LegalEntityDataDetails[i][LEColumns[j]]  = (LegalEntityDataDetails[i][LEColumns[j]] ? this.userService.getUTCDate_yyyyMMdd(LegalEntityDataDetails[i][LEColumns[j]]) :LegalEntityDataDetails[i][LEColumns[j]]);
          }
          if(_.includes(['customerType'], LEColumns[j])) {
            LegalEntityDataDetails[i][LEColumns[j]] = _.split(LegalEntityDataDetails[i][LEColumns[j]], '@');
          }
        }
      }
    }
    this.LegalEntityDataDetails=LegalEntityDataDetails;
    return this.LegalEntityDataDetails;
  }

  loadTabNameArray(dataDetailsArray: any, name: any,tabIndex?:any) {
    let tabNameArray = [{ id: 0, name: name,inCustomerRecordID:'',tabIndex: tabIndex}];
    if (dataDetailsArray.length > 0) {
      for (let i = 0; i < dataDetailsArray.length; i++) {
        let name = "";
        if(dataDetailsArray[i].hasOwnProperty('firstName') && dataDetailsArray[i].hasOwnProperty('lastName')) {
          name = this.getNaturalPersonTabName(dataDetailsArray[i]['firstName'],dataDetailsArray[i]['lastName'],dataDetailsArray[i]['inCustomerRecordID']);
        } else if (dataDetailsArray[i].hasOwnProperty('legalName')) {
          name = this.getLegalEntityTabName(dataDetailsArray[i]['legalName'], dataDetailsArray[i]['inCustomerRecordID']);
        }
        tabIndex = tabIndex+1;
        tabNameArray.push({
          id: dataDetailsArray[i]['id'],
          tabIndex:tabIndex,
          name: name,
          inCustomerRecordID:dataDetailsArray[i]['inCustomerRecordID']
        });
      }
    }
    return tabNameArray;
  }

  loadNaturalPersonDetails(naturalPersonDetails: any) {
    /* Natural Person Details */
    let NaturalPersonDataDetails = naturalPersonDetails.length > 0 ? naturalPersonDetails : [];
    /* Retrieve Foreign TID Country & Replacing Foreign TID Country */
    if (NaturalPersonDataDetails.length > 0) {
      for (let i = 0; i < NaturalPersonDataDetails.length; i++) {
        /* Set TID Update Flags */
          this.setClonedCustomerTIDFlag(NaturalPersonDataDetails[i], naturalPersonDetails); // Search & Set Cloned Customer Flag
        /* End of setting TID Update Flags */
        let NPColumns = Object.keys(NaturalPersonDataDetails[i]);
        for (let j = 0; j < NPColumns.length; j++) {
          if(_.includes(['roleStartDate', 'roleEndDate'], NPColumns[j])) {
            NaturalPersonDataDetails[i][NPColumns[j]]  = (NaturalPersonDataDetails[i][NPColumns[j]] ? this.userService.getUTCDate_yyyyMMdd(NaturalPersonDataDetails[i][NPColumns[j]]) :NaturalPersonDataDetails[i][NPColumns[j]]);
          }
          if(_.includes(['customerType'], NPColumns[j])) {
            NaturalPersonDataDetails[i][NPColumns[j]] = _.split(NaturalPersonDataDetails[i][NPColumns[j]], '@');
          }
        }
      }
    }
     this.maskYear();
     this.NaturalPersonDataDetails=NaturalPersonDataDetails;
    return this.NaturalPersonDataDetails;
  }

  prepareAddress(addrDetails: any) {
    let addressDetailsArray = [];
    if (addrDetails.length > 0) {
      for (let i = 0; i < addrDetails.length; i++) {
        let addressData = [];
        for (let j = 1; j <= 4; j++) {
          let address = {
            'addr_addrLine1': addrDetails[i]['addr' + j + '_addrLine1'] ? addrDetails[i]['addr' + j + '_addrLine1'] : '',
            'addr_addrLine2': addrDetails[i]['addr' + j + '_addrLine2'] ? addrDetails[i]['addr' + j + '_addrLine2'] : '',
            'addr_addrLine3': addrDetails[i]['addr' + j + '_addrLine3'] ? addrDetails[i]['addr' + j + '_addrLine3'] : '',
            'addr_addrLine4': addrDetails[i]['addr' + j + '_addrLine4'] ? addrDetails[i]['addr' + j + '_addrLine4'] : '',
            'addr_city': addrDetails[i]['addr' + j + '_city'] ? addrDetails[i]['addr' + j + '_city'] : '',
            'addr_regionCode': addrDetails[i]['addr' + j + '_regionCode'] ? addrDetails[i]['addr' + j + '_regionCode'] : '',
            'addr_countryCode': addrDetails[i]['addr' + j + '_countryCode'] ? addrDetails[i]['addr' + j + '_countryCode'] : '',
            'addr_postalCode': addrDetails[i]['addr' + j + '_postalCode'] ? addrDetails[i]['addr' + j + '_postalCode'] : ''
          }
          if(Object.values(address).some(value=>value && value.trim() !=='')){
            addressData.push(address);
          }
        }
        if(addressData.length ===0){
          addressData.push({'addr_addrLine1': '', 'addr_addrLine2': '', 'addr_addrLine3': '', 'addr_addrLine4': '', 'addr_city': '', 'addr_regionCode': '', 'addr_countryCode': '', 'addr_postalCode': ''})
        }
        addressDetailsArray.push(addressData);
      }
    }
    return addressDetailsArray;
  }

  getColumns() {
    let column: any;
    column = this.GridColumns;
    if (column !== null || column !== undefined) {
      this.cols = this.gridService.getGridColumns(column);
      this.filterCols = this.cols;
    }

    let addressColumn: any = this.AddressGridColumns;
    this.addressColumnJson = [];
    if (addressColumn != null || addressColumn != undefined) {
      this.addressColumns = this.gridService.getGridColumns(addressColumn);
      /* Adding Country & Region Code Menus */
      if (this.addressColumns.length > 0) {
        for (let i = 0; i < this.addressColumns.length; i++) {
          if (this.addressColumns[i]["header"] === "Country Code") {
            this.addressColumns[i]["dropdownvalue"] = this.userService.countryList;
          } else if (this.addressColumns[i]["header"] === "Region Code") {
            this.addressColumns[i]["dropdownvalue"] = this.userService.countryRegionList;
          }
        }
      }
    }

    /* Natural Person Grid Fields */
    let NaturalPersoncolumn: any;
    NaturalPersoncolumn = this.NaturalPersonGridColumns;
    if (NaturalPersoncolumn !== null || NaturalPersoncolumn !== undefined) {
      this.NaturalPersoncols = this.gridService.getGridColumns(NaturalPersoncolumn);
    }
    /* End of Natural Person Grid Fields */

    let LegalEntitycolumn: any;
    LegalEntitycolumn = this.LegalEntityGridColumns;
    if (LegalEntitycolumn !== null || LegalEntitycolumn !== undefined) {
      this.LegalEntitycols = this.gridService.getGridColumns(LegalEntitycolumn);
    }

    let LTIDcolumn: any;
    LTIDcolumn = this.LTIDGridColumns;
    if (LTIDcolumn !== null || LTIDcolumn !== undefined) {
      this.LTIDcols = this.gridService.getGridColumns(LTIDcolumn);
    }

    let TIDcolumn: any;
    TIDcolumn = this.TIDGridColumns;
    if (TIDcolumn !== null || TIDcolumn !== undefined) {
      this.TIDcols = this.gridService.getGridColumns(TIDcolumn);
    }

  }

  maskYear() {
    let birthYears:any = (this.storeBirthYear && this.storeBirthYear.length > 0 ? this.storeBirthYear : []);
    $(() => {
      $('.birthYear').each(function (index:any) {
        let value : any = $('#yearOfBirth' + index).val();
        if ($('#yearOfBirth' + index).val() && value.toString().length > 3 && !value.toString().includes("*")) {
          birthYears[index] = (value.toString());
        }
        if ($('#yearOfBirth' + index).val() && value.toString().length > 3) {
          const yearField = value.toString();
          $('#yearOfBirth' + index).val(yearField.substr(0, yearField.toString().length - 2) + '*'.repeat(2));
        }
      });
      this.storeBirthYear = birthYears;
    });
  }

  unMaskYear(eventValue:any) {
    let birthYears:any = this.storeBirthYear;
    $(() => {
      $('.birthYear').each(function (index:any) {
        let value:any = $('#yearOfBirth' + index).val();
        if (value && value.toString().length > 3) {
          $('#yearOfBirth' + index).val(birthYears[index]);
        }
      });
    });
  }

  getScreenData(selectedRowDetail: Object | any= {}) {

    /* Get all Address fields to Display */
    this.AddressGridColumns = _.sortBy(this.AddressGridColumns, 'sortOrder');
    this.AddressDetails = [];
    for (let i = 0; i < Object.keys(this.AddressGridColumns).length; i++) {
      this.AddressDetails.push({
        "ui_Field_Name": this.AddressGridColumns[i]["ui_columnname"],
        "field_Name": this.AddressGridColumns[i]["mappingkey"],
        "value": selectedRowDetail[this.AddressGridColumns[i]["db_columnname"]],
        "datatype": this.AddressGridColumns[i]["datatype"],
        "display": this.AddressGridColumns[i]["display"],
        "db_columnname": this.AddressGridColumns[i]["db_columnname"],
        "dropdown": this.AddressGridColumns[i]["dropdown"],
        "dropdowntype": this.AddressGridColumns[i]["dropdowntype"],
        "dropdownvalue": _.includes(this.CountryFields, this.AddressGridColumns[i]["ui_columnname"]) ? this.userService.countryList : this.AddressGridColumns[i]["dropdownvalue"],
        "isDisable": this.AddressGridColumns[i]["disabled"],
        "placeholder": (this.AddressGridColumns[i]["placeholder"] ? this.AddressGridColumns[i]["placeholder"] : "Please Enter Value"),
        "maximumLength": (this.AddressGridColumns[i]["maxlength"] ? this.AddressGridColumns[i]["maxlength"] : ""),
        "isrequired": (this.AddressGridColumns[i]["isrequired"] ? this.AddressGridColumns[i]["isrequired"] : false),
        "regexpressions": (this.AddressGridColumns[i]["regexpressions"] ? this.AddressGridColumns[i]["regexpressions"] : ""),
        "isOptionalFields": (this.AddressGridColumns[i]["isOptionalFields"] ? this.AddressGridColumns[i]["isOptionalFields"] : false)
      });
    }

    /* Get all Non-Address fields to Display */
    this.GridColumns = _.sortBy(this.GridColumns, 'sortOrder');
    this.fdidScreenDataDetails = [];
    for (let i = 0; i < Object.keys(this.GridColumns).length; i++) {
      if (!(/Address Line|City|Region Code|Country Code|Postal Code/.test(this.GridColumns[i]["ui_columnname"]))) {
        this.fdidScreenDataDetails.push({
          "ui_Field_Name": this.GridColumns[i]["ui_columnname"],
          "field_Name": this.GridColumns[i]["mappingkey"],
          "value": (_.includes(['Add', 'Edit'], this.actionType) && _.includes(['FDID Action'], this.GridColumns[i]["ui_columnname"])) ? (_.includes(['Add'], this.actionType) ? 'ADD' : 'UPDATE') : (_.includes(['Array'], this.GridColumns[i]["datatype"]) ? _.split(selectedRowDetail[this.GridColumns[i]["db_columnname"]], '@') : selectedRowDetail[this.GridColumns[i]["db_columnname"]]),
          "datatype": this.GridColumns[i]["datatype"],
          "display": this.GridColumns[i]["display"],
          "db_columnname": this.GridColumns[i]["db_columnname"],
          "dropdown": this.GridColumns[i]["dropdown"],
          "dropdowntype": this.GridColumns[i]["dropdowntype"],
          "dropdownvalue": _.includes(this.CountryFields, this.GridColumns[i]["ui_columnname"]) ? this.userService.countryList : (this.GridColumns[i]["dropdown"] === "YES" && this.userService.CAIS_Field_Dictionary[this.GridColumns[i]["db_columnname"]] ? _.cloneDeep(this.userService.CAIS_Field_Dictionary[this.GridColumns[i]["db_columnname"]]) : this.GridColumns[i]["dropdownvalue"]),
          "isDisable": (_.includes(['Add'], this.actionType) && _.includes(this.DisabledFields, this.GridColumns[i]["ui_columnname"])) ? true : (_.includes(['Edit'], this.actionType) && _.includes(this.DisabledFields, this.GridColumns[i]["ui_columnname"]) ? false : ((_.includes(['Edit'], this.actionType) && _.includes(this.editDisabledFields, this.GridColumns[i]["ui_columnname"])) ? true : this.GridColumns[i]["disabled"])),
          "placeholder": (this.GridColumns[i]["placeholder"] ? this.GridColumns[i]["placeholder"] : "Please Enter Value"),
          "maximumLength": (this.GridColumns[i]["maxlength"] ? this.GridColumns[i]["maxlength"] : ""),
          "isLargeField": (this.GridColumns[i]["isLargeFields"] ? this.GridColumns[i]["isLargeFields"] : false),
          "isrequired": (this.GridColumns[i]["isrequired"] ? this.GridColumns[i]["isrequired"] : false),
          "regexpressions": (this.GridColumns[i]["regexpressions"] ? this.GridColumns[i]["regexpressions"] : ""),
          "hasAlternativeField": (this.GridColumns[i]["hasAlternativeField"] ? this.GridColumns[i]["hasAlternativeField"] : false),
          "alternativeFields": (this.GridColumns[i]["alternativeFields"] ? this.GridColumns[i]["alternativeFields"] : ""),
          "isOptionalFields": (this.GridColumns[i]["isOptionalFields"] ? this.GridColumns[i]["isOptionalFields"] : false)
        });
      }
    }

    /* Get all Natural Person fields to Display */
    this.NaturalPersonGridColumns = _.sortBy(this.NaturalPersonGridColumns, 'sortOrder');
    this.NaturalPersonScreenDataDetails = [];
    for (let i = 0; i < Object.keys(this.NaturalPersonGridColumns).length; i++) {
      if (!(/Address Line|City|Region Code|Country Code|Postal Code/.test(this.NaturalPersonGridColumns[i]["ui_columnname"]))) {
        this.NaturalPersonScreenDataDetails.push({
          "ui_Field_Name": this.NaturalPersonGridColumns[i]["ui_columnname"],
          "field_Name": this.NaturalPersonGridColumns[i]["mappingkey"],
          "value": (_.includes(['Array'], this.NaturalPersonGridColumns[i]["datatype"]) ? _.split(selectedRowDetail[this.NaturalPersonGridColumns[i]["db_columnname"]], '@') : selectedRowDetail[this.NaturalPersonGridColumns[i]["db_columnname"]]),
          "datatype": this.NaturalPersonGridColumns[i]["datatype"],
          "display": this.NaturalPersonGridColumns[i]["display"],
          "db_columnname": this.NaturalPersonGridColumns[i]["db_columnname"],
          "dropdown": this.NaturalPersonGridColumns[i]["dropdown"],
          "dropdowntype": this.NaturalPersonGridColumns[i]["dropdowntype"],
          "dropdownvalue": _.includes(this.CountryFields, this.NaturalPersonGridColumns[i]["ui_columnname"]) ? this.userService.countryList : ((this.NaturalPersonGridColumns[i]["dropdown"] === "YES" && this.userService.CAIS_Field_Dictionary[this.NaturalPersonGridColumns[i]["db_columnname"]]) ? _.cloneDeep(this.userService.CAIS_Field_Dictionary[this.NaturalPersonGridColumns[i]["db_columnname"]]) : this.NaturalPersonGridColumns[i]["dropdownvalue"]),
          "isDisable": (_.includes(['Add'], this.actionType) && _.includes(this.DisabledFields, this.NaturalPersonGridColumns[i]["ui_columnname"])) ? true : (_.includes(['Edit'], this.actionType) && _.includes(this.DisabledFields, this.NaturalPersonGridColumns[i]["ui_columnname"]) ? false : ((_.includes(['Edit'], this.actionType) && _.includes(this.editDisabledFields, this.NaturalPersonGridColumns[i]["ui_columnname"])) ? true : this.NaturalPersonGridColumns[i]["disabled"])),
          "placeholder": (this.NaturalPersonGridColumns[i]["placeholder"] ? this.NaturalPersonGridColumns[i]["placeholder"] : "Please Enter Value"),
          "maximumLength": (this.NaturalPersonGridColumns[i]["maxlength"] ? this.NaturalPersonGridColumns[i]["maxlength"] : ""),
          "isLargeField": (this.NaturalPersonGridColumns[i]["isLargeFields"] ? this.NaturalPersonGridColumns[i]["isLargeFields"] : false),
          "isrequired": (this.NaturalPersonGridColumns[i]["isrequired"] ? this.NaturalPersonGridColumns[i]["isrequired"] : false),
          "regexpressions": (this.NaturalPersonGridColumns[i]["regexpressions"] ? this.NaturalPersonGridColumns[i]["regexpressions"] : ""),
          "isOptionalFields": (this.NaturalPersonGridColumns[i]["isOptionalFields"] ? this.NaturalPersonGridColumns[i]["isOptionalFields"] : false)
        });
      }
    }
    /* Disabling TID Type Option */
    let NPTIDTypeObjIndex:any = this.NaturalPersonScreenDataDetails.findIndex((objElement: { ui_Field_Name: string; }) => objElement.ui_Field_Name === "TID Type");
    this.NaturalPersonScreenDataDetails[NPTIDTypeObjIndex]["dropdownvalue"].reduce(function (previousValue: any[], currentValue: { disabled: boolean; value: string; }) {
      currentValue.disabled = ((currentValue.value === 'EIN') ? true : false);
      previousValue.push(currentValue);
      return previousValue;
    }, []);
    /* End of Disabling TID Type Option */

    /* Get all Legal Entity fields to Display */
    this.LegalEntityGridColumns = _.sortBy(this.LegalEntityGridColumns, 'sortOrder');
    this.LegalEntityScreenDataDetails = [];
    for (let i = 0; i < Object.keys(this.LegalEntityGridColumns).length; i++) {
      if (!(/Address Line|City|Region Code|Country Code|Postal Code/.test(this.LegalEntityGridColumns[i]["ui_columnname"]))) {
        this.LegalEntityScreenDataDetails.push({
          "ui_Field_Name": this.LegalEntityGridColumns[i]["ui_columnname"],
          "field_Name": this.LegalEntityGridColumns[i]["mappingkey"],
          "value": (_.includes(['Array'], this.LegalEntityGridColumns[i]["datatype"]) ? _.split(selectedRowDetail[this.LegalEntityGridColumns[i]["db_columnname"]], '@') : selectedRowDetail[this.LegalEntityGridColumns[i]["db_columnname"]]),
          "datatype": this.LegalEntityGridColumns[i]["datatype"],
          "display": this.LegalEntityGridColumns[i]["display"],
          "db_columnname": this.LegalEntityGridColumns[i]["db_columnname"],
          "dropdown": this.LegalEntityGridColumns[i]["dropdown"],
          "dropdowntype": this.LegalEntityGridColumns[i]["dropdowntype"],
          "dropdownvalue": _.includes(this.CountryFields, this.LegalEntityGridColumns[i]["ui_columnname"]) ? this.userService.countryList : ((this.LegalEntityGridColumns[i]["dropdown"] === "YES" && this.userService.CAIS_Field_Dictionary[this.LegalEntityGridColumns[i]["db_columnname"]]) ? _.cloneDeep(this.userService.CAIS_Field_Dictionary[this.LegalEntityGridColumns[i]["db_columnname"]]) : this.LegalEntityGridColumns[i]["dropdownvalue"]),
          "isDisable": (_.includes(['Add'], this.actionType) && _.includes(this.DisabledFields, this.LegalEntityGridColumns[i]["ui_columnname"])) ? true : (_.includes(['Edit'], this.actionType) && _.includes(this.DisabledFields, this.LegalEntityGridColumns[i]["ui_columnname"]) ? false : ((_.includes(['Edit'], this.actionType) && _.includes(this.editDisabledFields, this.LegalEntityGridColumns[i]["ui_columnname"])) ? true : this.LegalEntityGridColumns[i]["disabled"])),
          "placeholder": (this.LegalEntityGridColumns[i]["placeholder"] ? this.LegalEntityGridColumns[i]["placeholder"] : "Please Enter Value"),
          "maximumLength": (this.LegalEntityGridColumns[i]["maxlength"] ? this.LegalEntityGridColumns[i]["maxlength"] : ""),
          "isLargeField": (this.LegalEntityGridColumns[i]["isLargeFields"] ? this.LegalEntityGridColumns[i]["isLargeFields"] : false),
          "isrequired": (this.LegalEntityGridColumns[i]["isrequired"] ? this.LegalEntityGridColumns[i]["isrequired"] : false),
          "regexpressions": (this.LegalEntityGridColumns[i]["regexpressions"] ? this.LegalEntityGridColumns[i]["regexpressions"] : ""),
          "hasAlternativeField": (this.LegalEntityGridColumns[i]["hasAlternativeField"] ? this.LegalEntityGridColumns[i]["hasAlternativeField"] : false),
          "alternativeFields": (this.LegalEntityGridColumns[i]["alternativeFields"] ? this.LegalEntityGridColumns[i]["alternativeFields"] : ""),
          "isOptionalFields": (this.LegalEntityGridColumns[i]["isOptionalFields"] ? this.LegalEntityGridColumns[i]["isOptionalFields"] : false)
        });
      }
    }

    /* Disabling TID Type Option */
    let LETIDTypeObjIndex = this.LegalEntityScreenDataDetails.findIndex((objElement: { ui_Field_Name: string; }) => objElement.ui_Field_Name === "TID Type");
    this.LegalEntityScreenDataDetails[LETIDTypeObjIndex]["dropdownvalue"].reduce(function (previousValue: any[], currentValue: { disabled: boolean; value: string; }) {
      currentValue.disabled = ((currentValue.value === 'SSN/ITIN') ? true : false);
      previousValue.push(currentValue);
      return previousValue;
    }, []);
    /* End of Disabling TID Type Option */

    /* Get all LTID fields to Display */
    this.LTIDGridColumns = _.sortBy(this.LTIDGridColumns, 'sortOrder');
    this.LTIDScreenDataDetails = [];
    for (let i = 0; i < Object.keys(this.LTIDGridColumns).length; i++) {
      this.LTIDScreenDataDetails.push({
        "ui_Field_Name": this.LTIDGridColumns[i]["ui_columnname"],
        "field_Name": this.LTIDGridColumns[i]["mappingkey"],
        "value": selectedRowDetail[this.LTIDGridColumns[i]["db_columnname"]],
        "datatype": this.LTIDGridColumns[i]["datatype"],
        "display": this.LTIDGridColumns[i]["display"],
        "db_columnname": this.LTIDGridColumns[i]["db_columnname"],
        "dropdown": this.LTIDGridColumns[i]["dropdown"],
        "dropdowntype": this.LTIDGridColumns[i]["dropdowntype"],
        "dropdownvalue": (this.LTIDGridColumns[i]["dropdown"] === "YES" && this.userService.CAIS_Field_Dictionary[this.LTIDGridColumns[i]["db_columnname"]] ? _.cloneDeep(this.userService.CAIS_Field_Dictionary[this.LTIDGridColumns[i]["db_columnname"]]) : this.LTIDGridColumns[i]["dropdownvalue"]),
        "isDisable": this.LTIDGridColumns[i]["disabled"],
        "placeholder": (this.LTIDGridColumns[i]["placeholder"] ? this.LTIDGridColumns[i]["placeholder"] : "Please Enter Value"),
        "maximumLength": (this.LTIDGridColumns[i]["maxlength"] ? this.LTIDGridColumns[i]["maxlength"] : ""),
        "isrequired": (this.LTIDGridColumns[i]["isrequired"] ? this.LTIDGridColumns[i]["isrequired"] : false),
        "regexpressions": (this.LTIDGridColumns[i]["regexpressions"] ? this.LTIDGridColumns[i]["regexpressions"] : ""),
        "isOptionalFields": (this.LTIDGridColumns[i]["isOptionalFields"] ? this.LTIDGridColumns[i]["isOptionalFields"] : false)
      });
    }

  }

  getFormat(dateObj: any) {
    return (this.userService.getyyyyMMddDateFormate(dateObj));
  }

  formatData(DataObject: any) {
    for (const key in DataObject) {
      let data:any = /(GMT.*\))/.exec(DataObject[key]);
      if (typeof DataObject[key] === 'object' && data && data.length > 0) {
        DataObject[key] = DataObject[key] ? format(new Date(DataObject[key]), 'yyyy-MM-dd') : '';
      } else if (typeof DataObject[key] === 'object' && DataObject[key] && DataObject[key].length > 0) {
        DataObject[key] = DataObject[key].join('@');
      } else if(typeof DataObject[key] === 'string') {
        DataObject[key] = DataObject[key] ? DataObject[key].trim() : null;
      } else {
        DataObject[key] = DataObject[key] ? DataObject[key] : null;
      }
    }
  }

  /* Check AlterNative Fields' values from All form Field-List */
  checkAlterNativeFormField(screenField:any, AllScreenFields:any) {
    if(screenField["hasAlternativeField"]===true && screenField["isDisable"]!==true && (!screenField["value"] || screenField["value"]==="" || screenField["value"]===null)) {
      let hasAlternateValue = false;
      for(let k=0; k<screenField["alternativeFields"].length; k++) {
        let alternateField = AllScreenFields.filter((fieldRow:any) => fieldRow.field_Name===screenField["alternativeFields"][k]);
        if((alternateField[0]["value"] && alternateField[0]["value"]!==undefined)) {
          hasAlternateValue = true;
          break;
        }
      }
      if(!hasAlternateValue) {
        screenField["error"] = "Please enter " + screenField['field_Name'] + " OR " + screenField["alternativeFields"].join();
      } else {
        delete screenField["error"];
      }
    } else {
      delete screenField["error"];
    }
  }

  /* Validate Single Tab Form Data */
  validateSingleObjectFormFields(objectIndex: number, formData: string | any[], screenFields: string | any[]) {
    if (screenFields.length > 0) {
      for (let i = 0; i < screenFields.length; i++) {
        for (let j = 0; j < formData.length; j++) {
          if (objectIndex === j) {
            if (!formData[j]["errorFields"]) {
              formData[j]["errorFields"] = [];
            }
            /* Required Field Validation */
            if (screenFields[i]["isrequired"] === true && (!formData[j][screenFields[i].field_Name] || formData[j][screenFields[i].field_Name] === "" || formData[j][screenFields[i].field_Name] === null || (screenFields[i].datatype==='Array' && formData[j][screenFields[i].field_Name].length===0))) {
              formData[j]["errorFields"][screenFields[i].field_Name] = "Please enter required Field";
              continue;
            } else if (screenFields[i]["isrequired"] === true && (formData[j][screenFields[i].field_Name] || formData[j][screenFields[i].field_Name] !== "" || formData[j][screenFields[i].field_Name] !== null)) {
              delete formData[j]["errorFields"][screenFields[i].field_Name];
            }
            /* Alternative Field Validation */
            this.checkAlterNativeField(formData[j], screenFields[i]);
            /* Field format Validation */
            if (this.checkRegexpressionValidity(formData[j], screenFields[i])) {
              let validFieldFormat = false;
              for (let k = 0; k < screenFields[i]["regexpressions"].length; k++) {
                if (new RegExp(screenFields[i]["regexpressions"][k]).test(formData[j][screenFields[i].field_Name]) === true) {
                  validFieldFormat = true;
                  delete formData[j]["errorFields"][screenFields[i].field_Name];
                }
              }
              if (validFieldFormat === false) {
                formData[j]["errorFields"][screenFields[i].field_Name] = "Please enter valid format";
                continue;
              }
            }
          }
        }
      }
    }
  }

  validateFields(dataObj: any, screenFields: string | any[]) {
    if (screenFields.length > 0) {
      if (!dataObj["errorFields"]) {
        dataObj["errorFields"] = [];
      }
      for (let i = 0; i < screenFields.length; i++) {
        /* Required Field Validation */
        if (screenFields[i]["isrequired"] === true && screenFields[i]["isDisable"] !== true && (!dataObj[screenFields[i]['field_Name']] || dataObj[screenFields[i]['field_Name']] === "" || dataObj[screenFields[i]['field_Name']] === null || (screenFields[i]['datatype']==='Array' && dataObj[screenFields[i]['field_Name']].length===0))) {
          dataObj["errorFields"][screenFields[i]['field_Name']] = "Please enter required Field";
          continue;
        } else if (screenFields[i]["isrequired"] === true && dataObj[screenFields[i]['field_Name']]) {
          delete dataObj["errorFields"][screenFields[i]['field_Name']];
        }
        /* Alternative Field Validation */
        this.checkAlterNativeField(dataObj, screenFields[i]);
        /* Field format Validation */
        if (this.checkRegexpressionValidity(dataObj, screenFields[i])) {
          let validFieldFormat = false;
          for (let j = 0; j < screenFields[i]["regexpressions"].length; j++) {
            if (new RegExp(screenFields[i]["regexpressions"][j]).test(dataObj[screenFields[i]['field_Name']]) === true) {
              validFieldFormat = true;
              delete dataObj["errorFields"][screenFields[i]['field_Name']];
            }
          }
          if (validFieldFormat === false) {
            dataObj["errorFields"][screenFields[i]['field_Name']] = "Please enter valid format";
            continue;
          }
        }

      }
    }
  }

  isDisabled(rowDetail:any, customerObj:any) {
    if(_.includes(['foreignTIDCountryCd'], rowDetail.field_Name)) {
      return ((customerObj['tidType'] && _.includes(['FOREIGN'], customerObj['tidType']) && customerObj['foreignTIDType'] && _.includes(this.foreignTIDTypes, customerObj['foreignTIDType'])) ? false : true);
    } else if(_.includes(['foreignTIDType'], rowDetail.field_Name)) {
      return !_.includes(['FOREIGN'], customerObj['tidType']);
    } else if(_.includes(['hasDiscretion'], rowDetail.field_Name)) {
      return _.includes(this.customerRoleTypes, customerObj['role']);
    } else {
      return rowDetail.isDisable;
    }
  }

  /* Function Event on changing Dropdownbox value */
  onChangeSelectionBox(fieldDetail:any, customerObj:any) {
    if(_.includes(['tidType'], fieldDetail.field_Name) && customerObj[fieldDetail.field_Name]!=='FOREIGN') {
      customerObj['foreignTIDType'] = customerObj['foreignTIDCountryCd'] = null;
    }
    if (_.includes(['replacedByTIDType'], fieldDetail.field_Name) && fieldDetail.value!=='FOREIGN') {
      customerObj['replacingForeignTIDType'] = customerObj['replacingForeignTIDCountryCd'] = null;
    }
    if (_.includes(['foreignTIDType'], fieldDetail.field_Name) && customerObj[fieldDetail.field_Name]==='LEI') {
      customerObj['foreignTIDCountryCd'] = null;
    }
    if (_.includes(['replacingForeignTIDType'], fieldDetail.field_Name) && customerObj[fieldDetail.field_Name]==='LEI') {
      customerObj['replacingForeignTIDCountryCd'] = null;
    }
  }

  checkAlterNativeField(formDataObj:any, screenField:any) {
    if(screenField["hasAlternativeField"]===true && screenField["isDisable"]!==true && (!formDataObj[screenField.field_Name] || formDataObj[screenField.field_Name]==="" || formDataObj[screenField.field_Name]===null)) {
      let hasAlternateValue = false;
      for(let k=0; k<screenField["alternativeFields"].length; k++) {
        if((formDataObj[screenField["alternativeFields"][k]] && formDataObj[screenField["alternativeFields"][k]]!==undefined)) {
          hasAlternateValue = true;
          break;
        }
      }
      if(!hasAlternateValue) {
        formDataObj["errorFields"][screenField['field_Name']] = "Please enter " + screenField['field_Name'] + " OR " + screenField["alternativeFields"].join();
      } else {
        delete formDataObj["errorFields"][screenField['field_Name']];
      }
    } else {
      delete formDataObj["errorFields"][screenField['field_Name']];
    }
  }

  /* Previous Empty Address Fields Validation */
  previousEmptyAddressFieldValidation(currentIndex:any, addressDataObj:any, addressFields:any) {
    if(currentIndex > 0) {
      for(let j=currentIndex; j>=0; j--) {
        if(this.isEmptyObject(addressDataObj[j])) {
          this.validateFields(addressDataObj[j], addressFields); // Validating FDID Address Fields
        }
      }
    }
  }

  isEmptyObject(ObjectParams: Object | any) {
    if (Object.keys(ObjectParams).length > 0) {
      for (let key in ObjectParams) {
        if (key !== 'errorFields' && (ObjectParams[key] !== null && ObjectParams[key] !== "")) {
          return false;
        }
      }
      return true;
    }
    return true;
  }


  buildFDIDRecordPayloadToSave() {
    /* Field Validations */
    if (!this.formFieldValidation()) {
      return false;
    }
    /* End of Field Validations */
    // Create an FDID object
    let FDIDObj :any = {};
    if (Object.keys(this.FDIDScreenDataDetails).length > 0) {
      _.entries(this.FDIDScreenDataDetails).forEach((keyValArr) => {
        FDIDObj[keyValArr[0]] = keyValArr[1];
      });
      FDIDObj["action"] = "UPDATE";
    }
    this.formatData(FDIDObj); // Formatting Data
    /* LTID Data Array */
    let LTIDArrayObject = [];
    if (this.LTIDDataSet.length > 0) {
      for (let i = 0; i < this.LTIDDataSet.length; i++) {
        this.formatData(this.LTIDDataSet[i]); // Formatting Data
        if (!this.isEmptyObject(this.LTIDDataSet[i])) {
          LTIDArrayObject.push({ ...this.LTIDDataSet[i] });
        }
      }
    }
    // Create an FDID Address Array Object
    let FDIDAddressArray = [];
    if (this.FDIDAddressDetails.length > 0) {
      for (let j = 1; j <= this.FDIDAddressDetails.length; j++) {
        if (!this.isEmptyObject(this.FDIDAddressDetails[j - 1])) {
          FDIDAddressArray.push({
            "addrLine1": (this.FDIDAddressDetails[j - 1]["addr_addrLine1"] ? this.FDIDAddressDetails[j - 1]["addr_addrLine1"] : null),
            "addrLine2": (this.FDIDAddressDetails[j - 1]["addr_addrLine2"] ? this.FDIDAddressDetails[j - 1]["addr_addrLine2"] : null),
            "addrLine3": (this.FDIDAddressDetails[j - 1]["addr_addrLine3"] ? this.FDIDAddressDetails[j - 1]["addr_addrLine3"] : null),
            "addrLine4": (this.FDIDAddressDetails[j - 1]["addr_addrLine4"] ? this.FDIDAddressDetails[j - 1]["addr_addrLine4"] : null),
            "city": (this.FDIDAddressDetails[j - 1]["addr_city"] ? this.FDIDAddressDetails[j - 1]["addr_city"] : null),
            "regionCode": (this.FDIDAddressDetails[j - 1]["addr_regionCode"] ? this.FDIDAddressDetails[j - 1]["addr_regionCode"] : null),
            "countryCode": (this.FDIDAddressDetails[j - 1]["addr_countryCode"] ? this.FDIDAddressDetails[j - 1]["addr_countryCode"] : null),
            "postalCode": (this.FDIDAddressDetails[j - 1]["addr_postalCode"] ? this.FDIDAddressDetails[j - 1]["addr_postalCode"] : null)
          });
        }
      }
    }
    // Create an Natural Person Array Object
    let NaturalPersonArrayObject = [];
    if (this.NaturalPersonDataDetails.length > 0) {
      for (let i = 0; i < this.NaturalPersonDataDetails.length; i++) {
        /* Replacing Original Customer TID field values with Newer Customer TID field values */
        if(this.NaturalPersonDataDetails[i]['tidUpdate'] && this.NaturalPersonDataDetails[i]['tidUpdate']===this.TIDUpdateStatuses[0] && this.NaturalPersonDataDetails[(i+1)]['tidUpdate'] && this.NaturalPersonDataDetails[(i+1)]['tidUpdate']===this.TIDUpdateStatuses[1]) {
          this.replaceTIDUpdateFieldValues(this.NaturalPersonDataDetails[i], this.NaturalPersonDataDetails[i+1]);
        } // End of Logic for replacing Original Customer TID field values with Newer Customer TID field values
        if (!this.isEmptyObject(this.NaturalPersonDataDetails[i])) {
          this.NaturalPersonDataDetails[i]['active'] = 'Y';
          let NaturalPersonObjectItem = _.cloneDeep(this.NaturalPersonDataDetails[i]);
          this.formatData(NaturalPersonObjectItem); // Formatting Data
          NaturalPersonArrayObject.push({ ...NaturalPersonObjectItem });
        }
      }
    }
    // Create an Legal Entity Array Object
    let LegalEntityArrayObject = [];
    if (this.LegalEntityDataDetails.length > 0) {
      for (let i = 0; i < this.LegalEntityDataDetails.length; i++) {
        /* Replacing Original Customer TID field values with Newer Customer TID field values */
        if(this.LegalEntityDataDetails[i]['tidUpdate'] && this.LegalEntityDataDetails[i]['tidUpdate']===this.TIDUpdateStatuses[0] && this.LegalEntityDataDetails[(i+1)]['tidUpdate'] && this.LegalEntityDataDetails[(i+1)]['tidUpdate']===this.TIDUpdateStatuses[1]) {
          this.replaceTIDUpdateFieldValues(this.LegalEntityDataDetails[i], this.LegalEntityDataDetails[i+1]);
        } // End of Logic for replacing Original Customer TID field values with Newer Customer TID field values
        if (!this.isEmptyObject(this.LegalEntityDataDetails[i])) {
          this.LegalEntityDataDetails[i]['active'] = 'Y';
          let LegalEntityObjectItem = _.cloneDeep(this.LegalEntityDataDetails[i]);
          this.formatData(LegalEntityObjectItem); // Formatting Data
          LegalEntityArrayObject.push({ ...LegalEntityObjectItem });
        }
      }
    }

    // Create an Array of IncustomerIds of Removed Customers
    let removedCustomerAPIParam = this.removedCustomers.map(rcObj => rcObj.inCustomerRecordID);

    let APIParams = {
      type: "STAGING",
      CATReporterIMID: this.userService.getActiveMPID(),
      firmDesignatedID: FDIDObj["firmDesignatedID"],
      user: this.userService.getUserName(),
      userName: this.userService.getUserFirstName(),
      fdidDetails: FDIDObj,
      fdidAddrDetails: FDIDAddressArray,
      ltidDetails: LTIDArrayObject,
      legalEntityDetails: LegalEntityArrayObject,
      naturalPersonDetails: NaturalPersonArrayObject,
      removedCustomers: removedCustomerAPIParam,
      updatedUser: this.userService.getUserFirstName()
    };
    return APIParams;
  }


  formFieldValidation() {
    /* FDID Validation */
    let screenDataFields = this.fdidScreenDataDetails;
    screenDataFields = screenDataFields.filter((screenDataField: { ui_Field_Name: any; }) => (!_.includes(this.addScreenNegotiatedFields, screenDataField.ui_Field_Name) && !_.includes(this.ExceptionalFDIDScreenFields, screenDataField.ui_Field_Name)));

    // Check the mandatory requirement for Dependent fields
    this.checkDependentFieldRequirement(this.FDIDScreenDataDetails, screenDataFields, [{baseField: 'FDID End Date', dependentField: 'FDID End Reason', associatedFields: true}]);

    this.validateFields(this.FDIDScreenDataDetails, screenDataFields); // Validating FDID Data

    /* LTID Validation */
    if (this.LTIDDataSet.length > 0) {
      for (let i = 0; i < this.LTIDDataSet.length; i++) {
        if (!this.isEmptyObject(this.LTIDDataSet[i])) {
          this.validateFields(this.LTIDDataSet[i], this.LTIDScreenDataDetails); // Validating FDID Address Fields
        } else {
          delete this.LTIDDataSet[i].errorFields;
        }
      }
    }
    let LTIDDataSetErrorArray = this.LTIDDataSet.filter(LTIDDataSetObj => LTIDDataSetObj['errorFields'] && Object.keys(LTIDDataSetObj['errorFields']).length > 0);

    /* FDID Address Validation */
    if (this.FDIDAddressDetails.length > 0) {
      let addressFields = this.AddressDetails;
      for (let i = 0; i < this.FDIDAddressDetails.length; i++) {
        if (i==0 || !this.isEmptyObject(this.FDIDAddressDetails[i])) {
          /* Previous Empty Address Fields Validation */
            this.previousEmptyAddressFieldValidation(i, this.FDIDAddressDetails, addressFields);
          /* End of Previous Empty Address Fields Validation */
          this.validateFields(this.FDIDAddressDetails[i], addressFields); // Validating FDID Address Fields
        } else {
          delete this.FDIDAddressDetails[i].errorFields;
        }
      }
    }
    let FDIDAddressErrorArray = this.FDIDAddressDetails.filter((FDIDAddObj: any) => FDIDAddObj['errorFields'] && Object.keys(FDIDAddObj['errorFields']).length > 0);

    /* Natural Person Tabs Validation */
    let allValidNaturalPersons = true;
    if (this.NaturalPersonDataDetails.length > 0) {
      for (let i = 0; i < this.NaturalPersonDataDetails.length; i++) {
        allValidNaturalPersons = this.validateNaturalPerson(i);
        /* Validation for Initial Natural Person Tab */
        if (i === 0) {
          if (this.isEmptyObject(this.NaturalPersonDataDetails[i])) {
            delete this.NaturalPersonDataDetails[i].errorFields;
            allValidNaturalPersons = true;
          }
        }
        /* End of Validation for Initial Natural Person Tab */
        if (allValidNaturalPersons && this.NaturalPersonDataDetails[i].errorFields && Object.keys(this.NaturalPersonDataDetails[i].errorFields).length === 0) {
          delete this.NaturalPersonDataDetails[i].errorFields;
        }
        /* Stop Page submission while found Field error */
        if (!allValidNaturalPersons) {
          break;
        }
      }
    }
    /* End of Natural Person Tabs Validation */
    /* Legal Entity Tabs Validation */
    let allValidLegalEntities = true;
    if (this.LegalEntityDataDetails.length > 0) {
      for (let i = 0; i < this.LegalEntityDataDetails.length; i++) {
        allValidLegalEntities = this.validateLegalEntity(i);
        /* Validation for Initial Legal Entity Tab */
        if (i === 0) {
          if (this.isEmptyObject(this.LegalEntityDataDetails[i])) {
            delete this.LegalEntityDataDetails[i].errorFields;
            allValidLegalEntities = true;
          }
        }
        /* End of Validation for Initial Legal Entity Tab */
        if (allValidLegalEntities && this.LegalEntityDataDetails[i].errorFields && Object.keys(this.LegalEntityDataDetails[i].errorFields).length === 0) {
          delete this.LegalEntityDataDetails[i].errorFields;
        }
        /* Stop Page submission while found Field error */
        if (!allValidLegalEntities) {
          break;
        }
      }
    }
    /* End of Legal Entity Tabs Validation */

    /* Final Validation Result */
    if (Object.keys(this.FDIDScreenDataDetails.errorFields).length > 0 || LTIDDataSetErrorArray.length > 0 || FDIDAddressErrorArray.length > 0 || !allValidNaturalPersons || !allValidLegalEntities) {
      return false;
    }
    return true;
  }

  validateNaturalPerson(objectIndex:any) {
    let naturalPersonScreenDataFields = this.NaturalPersonScreenDataDetails;
    naturalPersonScreenDataFields = naturalPersonScreenDataFields.filter((naturalPersonScreenDataField: { ui_Field_Name: any; }) => (!_.includes(this.addScreenNegotiatedFields, naturalPersonScreenDataField.ui_Field_Name)));

    // Check the mandatory requirement for Dependent fields
    this.checkDependentFieldRequirement(this.NaturalPersonDataDetails[objectIndex], naturalPersonScreenDataFields, [{baseField: 'Role End Date', dependentField: 'Role End Reason', associatedFields: true}, {baseField: 'TID Type', baseFieldValues: this.TIDTypes, dependentField: 'Foreign TID Type'}, {baseField: 'Foreign TID Type', baseFieldValues: this.foreignTIDTypes, dependentField: 'Foreign TID Country'}, {baseField: 'Role', baseFieldValues: this.customerDiscretionRoleTypes, dependentField: 'Has Discretion'}]);

    this.validateSingleObjectFormFields(objectIndex, this.NaturalPersonDataDetails, naturalPersonScreenDataFields);

    /* Check Role */
    this.validateRole(objectIndex, this.NaturalPersonDataDetails);

    /* Natural Person Address Fields */
    if (this.NaturalPersonAddressDetails.length > 0) {
      this.dataService.formAddressDetails(this.AddressDetails, this.NaturalPersonDataDetails[objectIndex], this.NaturalPersonAddressDetails[objectIndex]); // Assign Address Field Values
    }
    /* Natural Person Address Validation */
    if (this.NaturalPersonAddressDetails[objectIndex].length > 0) {
      let addressFields = this.AddressDetails;
      for (let i = 0; i < this.NaturalPersonAddressDetails[objectIndex].length; i++) {
        if ((i==0 && !this.isEmptyObject(this.NaturalPersonDataDetails[objectIndex])) || !this.isEmptyObject(this.NaturalPersonAddressDetails[objectIndex][i])) {
          /* Previous Empty Address Fields Validation */
            this.previousEmptyAddressFieldValidation(i, this.NaturalPersonAddressDetails[objectIndex], addressFields);
          /* End of Previous Empty Address Fields Validation */
          this.validateFields(this.NaturalPersonAddressDetails[objectIndex][i], addressFields); // Validating Natural Person Address Fields
        } else {
          delete this.NaturalPersonAddressDetails[objectIndex][i].errorFields;
        }
      }
    }
    let NaturalPersonAddressErrorArray = this.NaturalPersonAddressDetails[objectIndex].filter((NaturalPersonAddObj:any) => NaturalPersonAddObj['errorFields'] && Object.keys(NaturalPersonAddObj['errorFields']).length > 0);
    /* End of Natural Person Address Validation */
    /* End of Natural Person Address Fields */
    /* Stop Page submission while found Field error */
    if ((this.NaturalPersonDataDetails[objectIndex] && Object.keys(this.NaturalPersonDataDetails[objectIndex].errorFields).length > 0) || NaturalPersonAddressErrorArray.length > 0) {
      return false;
    } else {
      return true;
    }
  }

  validateLegalEntity(objectIndex:any) {
    let legalEntityScreenDataFields = this.LegalEntityScreenDataDetails;
    legalEntityScreenDataFields = legalEntityScreenDataFields.filter((legalEntityScreenDataField: { ui_Field_Name: any; }) => (!_.includes(this.addScreenNegotiatedFields, legalEntityScreenDataField.ui_Field_Name)));

    // Check the mandatory requirement for Dependent fields
    this.checkDependentFieldRequirement(this.LegalEntityDataDetails[objectIndex], legalEntityScreenDataFields, [{baseField: 'Role End Date', dependentField: 'Role End Reason', associatedFields: true}, {baseField: 'TID Type', baseFieldValues: this.TIDTypes, dependentField: 'Foreign TID Type'}, {baseField: 'Foreign TID Type', baseFieldValues: this.foreignTIDTypes, dependentField: 'Foreign TID Country'}, {baseField: 'Role', baseFieldValues: this.customerDiscretionRoleTypes, dependentField: 'Has Discretion'}]);

    this.validateSingleObjectFormFields(objectIndex, this.LegalEntityDataDetails, legalEntityScreenDataFields);

    /* Check Role */
    this.validateRole(objectIndex, this.LegalEntityDataDetails);

    /* Legal Entity Address Fields */
    if (this.LegalEntityAddressDetails.length > 0) {
      this.dataService.formAddressDetails(this.AddressDetails, this.LegalEntityDataDetails[objectIndex], this.LegalEntityAddressDetails[objectIndex]); // Assign Address Field Values
    }
    /* Legal Entity Address Validation */
    if (this.LegalEntityAddressDetails[objectIndex].length > 0) {
      let addressFields = this.AddressDetails;
      for (let i = 0; i < this.LegalEntityAddressDetails[objectIndex].length; i++) {
        if ((i==0 && !this.isEmptyObject(this.LegalEntityDataDetails[objectIndex])) ||!this.isEmptyObject(this.LegalEntityAddressDetails[objectIndex][i])) {
          /* Previous Empty Address Fields Validation */
            this.previousEmptyAddressFieldValidation(i, this.LegalEntityAddressDetails[objectIndex], addressFields);
          /* End of Previous Empty Address Fields Validation */
          this.validateFields(this.LegalEntityAddressDetails[objectIndex][i], addressFields); // Validating Natural Person Address Fields
        } else {
          delete this.LegalEntityAddressDetails[objectIndex][i].errorFields;
        }
      }
    }
    let LegalEntityAddressErrorArray = this.LegalEntityAddressDetails[objectIndex].filter((LegalEntityAddObj:any) => LegalEntityAddObj['errorFields'] && Object.keys(LegalEntityAddObj['errorFields']).length > 0);
    /* End of Legal Entity Address Validation */
    /* End of Legal Entity Address Fields */

    /* Stop Page submission while found Field error */
    if ((this.LegalEntityDataDetails[objectIndex] && Object.keys(this.LegalEntityDataDetails[objectIndex].errorFields).length > 0) || LegalEntityAddressErrorArray.length > 0) {
      return false;
    } else {
      return true;
    }
  }

  /* Check Regular Expression Validity */
  checkRegexpressionValidity(screenDataFieldValue:any, screenFields:any) {
    if(!_.includes(['addr_postalCode'], screenFields['field_Name']) && screenDataFieldValue[screenFields['field_Name']] && screenFields["regexpressions"] && screenFields["regexpressions"].length > 0) {
      return true;
    } else if(_.includes(['addr_postalCode'], screenFields['field_Name']) && !_.includes(['US', 'CA'], screenDataFieldValue['addr_countryCode'])) {
      return false;
    }
    return false;
  }

  /* Check the mandatory requirement for the Dependent Fields */
  checkDependentFieldRequirement(dataObj:any, screenFields:any, dependantFields:any) {
    if(dependantFields.length > 0) {
      for(let i = 0; i < dependantFields.length; i++) {
        let baseFieldIndex = screenFields.findIndex((filterElem:any) => filterElem.ui_Field_Name === dependantFields[i].baseField);
        let dependentFieldIndex = screenFields.findIndex((filterElem:any) => filterElem.ui_Field_Name === dependantFields[i].dependentField);
        if(baseFieldIndex > 0 && dependentFieldIndex > 0) {
          let baseFieldValue = (Object.keys(dataObj).length > 0 ? dataObj[screenFields[baseFieldIndex].field_Name] : (Object.keys(dataObj).length === 0 && screenFields[baseFieldIndex] ? screenFields[baseFieldIndex].value : ''));
          let dependentFieldValue = (Object.keys(dataObj).length > 0 ? dataObj[screenFields[dependentFieldIndex].field_Name] : (Object.keys(dataObj).length === 0 && screenFields[dependentFieldIndex] ? screenFields[dependentFieldIndex].value : ''));

          if(dependantFields[i].baseFieldValues && dependantFields[i].baseFieldValues.length > 0) {
            screenFields[dependentFieldIndex]["isrequired"] = ((baseFieldValue && dependantFields[i].baseFieldValues.includes(baseFieldValue) && !dependentFieldValue) ? true : false);
          } else {
            screenFields[dependentFieldIndex]["isrequired"] = ((baseFieldValue && !dependentFieldValue) ? true : false);
          }
          // Check Associated field mandatory requirement (Field A->Field B also must fulfills Field B->Field A)
          if(dependantFields[i].associatedFields) {
            screenFields[baseFieldIndex]["isrequired"] = ((dependentFieldValue && !baseFieldValue) ? true : false);
          }
        }
      }
    }
  }

  /* TId Existence Validation */
  checkTIDExistence(formDataObj:any, naturalPersonDataObject:any, legalEntityDataObject:any) {
    if(naturalPersonDataObject.filter((customerDetail:any) => (customerDetail.tidValue === formDataObj.tidValue)).length > 1 || legalEntityDataObject.filter((customerDetail: { tidValue: any; }) => (customerDetail.tidValue === formDataObj.tidValue)).length > 1) {
      if(!formDataObj["errorFields"]) {
        formDataObj["errorFields"] = [];
      }
      formDataObj["errorFields"]["tidValue"] = "TID value is already exist";
    }
  }

  TIDGenerator(token:any) {
    return this.sharedHttpClientService.post(this.urlService.setAPIURl(APIURL.CAIS_Generate_TID_Hash), {tidValue: token})
      .pipe(map((response: any) => {
        return response;      
      }));
  }

  /* Replacing Original Customer TID field values with Newer Customer TID field values */
  replaceTIDUpdateFieldValues(originCustomerObject:any, updatedCustomerObject:any) {
    let replacedTIDFields = ['replacedByTID', 'replacedByTIDType', 'replacingForeignTIDType', 'replacingForeignTIDCountryCd'];
    let updatedTIDFields = ['tidValue', 'tidType', 'foreignTIDType', 'foreignTIDCountryCd'];
    for (let i=0; i<replacedTIDFields.length; i++) {
      originCustomerObject[replacedTIDFields[i]] = updatedCustomerObject[updatedTIDFields[i]];
    }
    originCustomerObject['roleEndDate'] = this.userService.getyyyyMMddDateFormate(new Date());
    originCustomerObject['roleEndReason'] = 'REPLACED';
  }

  /* Set Cloned Customer TID Update Flag */
  setClonedCustomerTIDFlag(customerObj:any, customerObjList:any) {
    if(customerObj['tidValue'] !== null && customerObj['tidValue'] !== undefined && customerObj['replacedByTID'] !== null && customerObj['replacedByTID'] !== undefined) {
      customerObj['tidUpdate'] = this.TIDUpdateStatuses[0];
    
      let searchClonedCustomerIndex = customerObjList.findIndex((elemObj:any) => elemObj.tidValue === customerObj.replacedByTID);
      if(searchClonedCustomerIndex > 0) {
        customerObjList[searchClonedCustomerIndex]['tidUpdate'] = this.TIDUpdateStatuses[1];
      }
    }
  }

  validateRole(objectIndex:any,CustomerDetails:any) {
    if(CustomerDetails[objectIndex]["role"]!=null 
    && CustomerDetails[objectIndex]["role"].trim().length>0 && CustomerDetails[objectIndex]["role"] === 'AUTH3RD') {
      CustomerDetails[objectIndex]["errorFields"]['role'] = "‘AUTH3RD’ is not supported";
    }
  }

  getNaturalPersonTabName(firstName: string, lastName: string, inCustomerRecordID: string) {
    
    let name = "NP";

    if (firstName) name = firstName;
    if (lastName) name = name && name!=="NP" ? `${name} ${lastName}` : lastName;
    if (!firstName && !lastName && inCustomerRecordID) {
      name = name.concat(" - ", `${inCustomerRecordID}`);
    }

    return name;
  }

  getLegalEntityTabName(legalEntityName: string, inCustomerRecordID: string) {
    let name = "LE";
 
    if(legalEntityName) {
      name = legalEntityName;
    } else if (!legalEntityName && inCustomerRecordID) {
      name = name.concat(" - ", inCustomerRecordID);
    }

    return name;
  }

  updateForeginTIDValue(type: 'LegalEntity' | 'NaturalPerson', value:any){
    if(type==='LegalEntity'){
      this.LegalEntityForeignTIDValue.next(value);
    }
    else{
      this.NaturalPersonForeignTIDValue.next(value);
    }
  }

  emptyForeginTIDValue(type: 'LegalEntity' | 'NaturalPerson'){
    if(type==='LegalEntity'){
      this.LegalEntityForeignTIDValue.next(null);
    }
    else{
      this.NaturalPersonForeignTIDValue.next(null);
    }
  }

  // Returns true if at least one object matches the condition for Display and not an OptionalField
  hasAnyActiveField(gridObjArray: any): boolean {
    return gridObjArray.some((gridObj: any) => gridObj.display === true && gridObj.isOptionalFields === true);
  }

}